// import { getFetchMock } from './mocks/fetch';
import { request } from '../request';
import { AgencyDetails } from '@libs/models/agencies';

export async function fetchAgencyDetails(id: string): Promise<AgencyDetails> {
  const response = await request.get<AgencyDetailsResponseItem>(`/agencies/${id}`);
  return {
    ...response.data,
    address: {
      addressFirst: response.data.address.addressLine1,
      addressSecond: response.data.address.addressLine2,
      city: response.data.address.city,
      state: response.data.address.state,
      zipCode: response.data.address.zipCode,
    },
    linesOfBusiness: response.data.linesOfBusiness,
    status: response.data.status ?? 'Active',
  };
}

type AgencyDetailsResponseItem = {
  id: string;
  name: string;
  tenantId: string;
  createdOn: string;
  agencyType: string;
  linesOfBusiness: string[];
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview' | 'Invited';
};
